/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_NavInputs */

const en_svc_n8n_nav = /** @type {(inputs: Svc_N8n_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n automation`)
};

const lv_svc_n8n_nav = /** @type {(inputs: Svc_N8n_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`n8n automatizācija`)
};

/**
* | output |
* | --- |
* | "n8n automation" |
*
* @param {Svc_N8n_NavInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_nav = /** @type {((inputs?: Svc_N8n_NavInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_NavInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_nav(inputs)
	return en_svc_n8n_nav(inputs)
});